module.exports = __webpack_public_path__ + "img/achievementsLock.cd5dec3d.svg";